import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export function useCalculateSceneDate () {
  const calculateSceneDate = (date: string) => {
    const dateCET = dayjs.utc(date).tz("Europe/Madrid");

    return {
      day: dateCET.format("YYYY-MM-DD"),
      hour: dateCET.format("HH:mm:ss"),
    };
  }
  const formatSceneDuration = (durationInSeconds: number) => {
    return dayjs.utc(durationInSeconds * 1000).format('HH:mm:ss');
  }
  return { calculateSceneDate, formatSceneDuration };
}
